<template>
  <ul v-if="unsupported" class="form">
    <li class="danger-text">
      {{ t(`${parentComponentName}.${productCode}Unsupported`) }}
    </li>
    <li>
      {{ t(`${parentComponentName}.${productCode}UnsupportedReference`) }}
      <Keycodes :keycodes="keycodes" />
    </li>
  </ul>
  <ol v-else class="form">
    <li>
      <p>{{ t(`${parentComponentName}.${productCode}StepOne`) }}</p>
      <SelectorComponent :product-code="productCode" />
    </li>
    <li>
      <p>{{ t(`${parentComponentName}.${productCode}StepTwo`) }}</p>
      <Keycodes :keycodes="keycodes" />
    </li>
  </ol>
  <p>{{ t(`${parentComponentName}.timeDelayWarning`) }}</p>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, computed } from "vue";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import { ISubscriberDownloadsInfo, IListOptions } from "@/common/api/unifiedPortal/interfaces";
import Keycodes from "@/components/Downloads/Keycodes.vue";
import SelectorComponent from "@/components/shared/dialogs/DownloadProduct/Selector.vue";

const productCode = "WSAV";
const componentName = `${productCode}ProductComponent`;
const parentComponentName = "DownloadProductComponent";

export default defineComponent({
  name: componentName,
  components: { Keycodes, SelectorComponent },
  props: {
    keycodes: {
      type: Object as PropType<ISubscriberDownloadsInfo>,
      default: null,
    },
    isUnsupportedOs: {
      type: Boolean,
      default: null,
    },
  },
  setup(props) {
    logEvent("created", componentName, props);
    const listOptions = ref<IListOptions[]>([]);
    const unsupported = computed(() => props.isUnsupportedOs);

    //Expose the template
    return {
      t,
      unsupported,
      listOptions,
      parentComponentName,
      productCode,
    };
  },
});
</script>

<style scoped lang="css">
@import "@/styles/variables.css";
</style>
